//reference https://stackoverflow.com/questions/42672842/how-to-get-history-on-react-router-v4
import { browserHistory } from 'react-router';

let historyList = {
  current: () => historyList.locations[historyList.locations.length - 1],
  previous: () => historyList.locations.length >= 2 ? historyList.locations[historyList.locations.length - 2] : null,
  locations: []
};

browserHistory.listen(location => {
  switch (location.action) {
    case 'REPLACE':
      historyList.locations.pop();
      historyList.locations.push(location);
      break;
    case 'POP':
      let previous = historyList.previous() || {};
      if (location.pathname !== previous.pathname) {
        // We should push.
        historyList.locations.push(location);
      } else {
        previous = historyList.locations.pop();
      }

      if (historyList.locations.length === 0) {
        historyList.locations.push({ pathname: location.pathname });
      }

      // Store previous so we know where we're coming from
      if (previous) {
        let current = historyList.current();
        current.previous = previous;
      }

      break;
    case 'PUSH':
      historyList.locations.push(location);
      break;
    default:
  }

  return location;
});

export default historyList;



/** WEBPACK FOOTER **
 ** ./src/lib/history.js
 **/